import React, {
  useEffect,
  useContext,
  useState,
  useRef,
  useCallback,
} from 'react'
import axios from 'axios'
import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import UserAvatar from '../Avatar/UserAvatar'
import styles from './AvatarRoles.module.css'
import useWebSocket from 'react-use-websocket'
import RowAutocomplete from './components/RowAutocomplete/RowAutocomplete'
import { BuilderContext } from '../../pages/Sandbox/components/store/store.Builder'
import { observer } from 'mobx-react-lite'
import RowUserAcces from './components/RowUserAcces/RowUserAcces'
import { searchUsers } from '../../services/api'
import {
  Dropdown,
  Space,
  AutoComplete,
  Divider,
  message,
  Select,
  Button,
  Upload,
} from 'antd'
import { buildTimeValue } from '@testing-library/user-event/dist/utils'
import { SvgMore } from '../svg/SvgComponents'
import UserSearchBar from './components/UserSearchBar/UserSearchBar'
import { toJS } from 'mobx'
import { Modal } from 'antd'
import Papa from 'papaparse'

const AvatarRoles = observer(
  ({
    url_code,
    userUsername,
    userFullName,
    dataAPI,
    showRights,
    onAddUser,
    onEditUser,
    onDeleteUser,
    title,
    isAdmin = false,
  }) => {
    const builderContext = useContext(BuilderContext)

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isImporting, setIsImporting] = useState(false)

    const { Option } = Select
    const [options, setOptions] = useState([])
    const [searching, setSearching] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [autoCompleteValue, setAutoCompleteValue] = useState('')
    const [selectedOption, setSelectedOption] = useState('write')
    const fileInputRef = useRef(null)

    const showModal = () => {
      setIsModalVisible(true)
    }

    const handleModalClose = () => {
      setIsModalVisible(false)
    }

    const handleImportCSV = async (file) => {
      setIsImporting(true)

      const reader = new FileReader()
      reader.onload = async (e) => {
        try {
          const csvText = e.target.result
          Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            complete: async (results) => {
              const emails = results.data
                .map((row) => {
                  // Look for email in any column
                  const email = Object.values(row).find(
                    (value) => typeof value === 'string' && value.includes('@')
                  )
                  return email?.trim()
                })
                .filter(Boolean)

              if (emails.length === 0) {
                message.error(
                  'Aucune adresse email trouvée dans le fichier CSV'
                )
                setIsImporting(false)
                return
              }

              message.info(
                `Import de ${emails.length} adresse(s) email en cours...`
              )

              let successCount = 0
              let errorCount = 0

              for (const email of emails) {
                try {
                  // Search for user by email
                  const abortController = axios.CancelToken.source()
                  const userData = await searchUsers(
                    email,
                    abortController.token
                  )

                  if (userData?.users && userData.users.length > 0) {
                    const user = userData.users[0]
                    const [firstName, lastName] = user.cn?.split(' ') || [
                      '',
                      '',
                    ]

                    const formData = {
                      permission: selectedOption,
                      form_url_code: url_code,
                      user_username: user.uid,
                      user_mail: user.mail || email,
                      user_first_name: firstName,
                      user_last_name: lastName,
                    }

                    await onAddUser(formData)
                    successCount++
                  } else {
                    console.warn(
                      `Utilisateur non trouvé pour l'email: ${email}`
                    )
                    errorCount++
                  }
                } catch (error) {
                  console.error(`Erreur lors de l'import de ${email}:`, error)
                  errorCount++
                }
              }

              if (successCount > 0) {
                message.success(
                  `${successCount} utilisateur(s) ajouté(s) avec succès`
                )
              }
              if (errorCount > 0) {
                message.warning(
                  `${errorCount} utilisateur(s) n'ont pas pu être ajoutés`
                )
              }

              setIsImporting(false)
            },
            error: (error) => {
              console.error('Erreur lors du parsing du CSV:', error)
              message.error('Erreur lors de la lecture du fichier CSV')
              setIsImporting(false)
            },
          })
        } catch (error) {
          console.error("Erreur lors de l'import CSV:", error)
          message.error("Erreur lors de l'import")
          setIsImporting(false)
        }

        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = ''
        }
      }

      reader.onerror = () => {
        console.error('Erreur lors de la lecture du fichier')
        message.error('Erreur lors de la lecture du fichier')
        setIsImporting(false)
      }

      reader.readAsText(file)
    }

    const renderCountRef = useRef(0)
    renderCountRef.current += 1

    useEffect(() => {
      console.log(`AvatarRoles render count: ${renderCountRef.current}`)
      console.log('dataAPIIIIIIIIIIIIIIII', toJS(dataAPI))
    })

    const onSelect = async (selectedUser) => {
      console.log('selectUser', selectedUser)
      try {
        const formData = {
          permission: selectedUser.right,
          form_url_code: url_code,
          user_username: selectedUser.user,
          user_mail: selectedUser.mail || '',
          user_first_name: selectedUser.firstName,
          user_last_name: selectedUser.lastName,
        }
        await onAddUser(formData)
      } catch (error) {
        console.error("Erreur lors de l'ajout du collaborateur :", error)
      }
    }

    const menu = (
      <div className={styles.dropdown}>
        <div className={styles.container__title}>
          <h3>Donner accès à un utilisateur</h3>
        </div>

        <UserSearchBar
          onSelect={onSelect}
          showRights={showRights}
          dataAPI={dataAPI}
        />
        <Divider />
        {isAdmin && (
          <div style={{ marginBottom: '16px' }}>
            <input
              type="file"
              accept=".csv"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0]
                if (file) {
                  handleImportCSV(file)
                }
              }}
            />
            <Button
              icon={<UploadOutlined />}
              onClick={() => fileInputRef.current?.click()}
              loading={isImporting}
              block
            >
              Importer des emails depuis un CSV
            </Button>
            <p
              style={{
                fontSize: '12px',
                color: '#666',
                marginTop: '8px',
                marginBottom: 0,
              }}
            >
              Le fichier CSV doit contenir une colonne avec des adresses email
            </p>
          </div>
        )}
        {isAdmin && <Divider />}
        <div>
          <h3>Personnes disposant de l'accès</h3>
          {dataAPI.length === 0 ? (
            <p>
              <br></br>
              Personne ne dispose des droits. Ajoutez des personnes en
              recherchant dans la barre de recherche.
              <br></br>
            </p>
          ) : (
            dataAPI.map((collaborator) => (
              <RowUserAcces
                key={collaborator.username}
                user={collaborator}
                showRights={showRights}
                onEditUser={onEditUser}
                onDeleteUser={onDeleteUser}
              />
            ))
          )}
        </div>
      </div>
    )

    const avatarDimensions = {
      width: 28,
      height: 29,
      size: 'medium',
      shape: 'square',
      fontSize: '12px',
    }

    return (
      <div className={styles.container}>
        <div className={styles.container__avatars}>
          {dataAPI.some(
            (collaborator) => collaborator.username === userUsername
          ) && (
            <UserAvatar
              key={userUsername}
              userName={userFullName}
              {...avatarDimensions}
            />
          )}

          <div className={styles.container__avatars_others}>
            {dataAPI
              .filter((collaborator) => collaborator.username !== userUsername)
              .slice(0, 1)
              .map((collaborator) => (
                <UserAvatar
                  key={collaborator.username}
                  userName={collaborator.full_name}
                  {...avatarDimensions}
                />
              ))}
            {dataAPI.length > 2 && (
              <div className={styles.additionalUsers}>
                +{dataAPI.length - 2}
              </div>
            )}
          </div>
        </div>

        <div className={styles.container__button}>
          <a className={styles.button__add} onClick={showModal}>
            <Space>
              <PlusOutlined />
            </Space>
          </a>
          <Modal
            centered
            title={title}
            open={isModalVisible}
            onCancel={handleModalClose}
            maskClosable={true}
            footer={null} // Aucun bouton par défaut
          >
            {menu}
          </Modal>
        </div>
      </div>
    )
  }
)

export default AvatarRoles
